import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import { useContext } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSearchForm',
  props: {
  value: {
    type: String,
    default: null,
  },
},
  emits: ['search', 'input'],
  setup(__props, { emit }) {

const props = __props;





const { $gtm } = useContext();

const input = ref();
const isFormStartEventSended = ref(false);
const pushFormStartEvent = () => {
  if (!isFormStartEventSended.value) {
    $gtm.push({
      event: 'form_start',
    });
  }
  isFormStartEventSended.value = true;
};
const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    pushFormStartEvent();
    emit('input', newValue);
  },
});

const focusInput = () => input.value.focus();

const search = () => {
  emit('search', valueLocal.value);
};

onMounted(() => {
  focusInput();
});

return { __sfc: true,props, emit, $gtm, input, isFormStartEventSended, pushFormStartEvent, valueLocal, focusInput, search }
}

})